<template>
    <div class="layout-topbar">
        <div class="topbar-left">
            <a tabindex="0" class="menu-button" @click="onMenuButtonClick">
                <i class="pi responsive-menu-button" style="background-image: url('assets/irinox/icons/menu.svg'); background-size: 85%;"></i>
            </a>

            <img id="irinox-main-logo" class="irinox-main-logo" src="assets/irinox/logo/header.svg" alt="Irinox FreshCloud" />

            <router-link to="/" class="horizontal-logo">
                <img id="logo-horizontal" class="horizontal-logo" src="assets/layout/images/logo-dark.svg" alt="diamond-layout" />
            </router-link>

            <!-- <span class="topbar-separator"></span> -->
           
            <!-- <div class="layout-breadcrumb viewname" style="text-transform: uppercase">
                <template v-if="$route.meta.breadcrumb">
                    <span>{{$route.meta.breadcrumb[0].label}}</span>
                </template>
            </div> -->

            <img id="logo-mobile" class="mobile-logo" src="assets/irinox/logo/menu-small.svg" alt="Irinox FreshCloud" />
        </div>

        <AppMenu :model="menu" :layoutMode="layoutMode" :active="menuActive" :mobileMenuActive="staticMenuMobileActive"
                 @menu-click="onMenuClick" @menu-button-click="onMenuButtonClick" @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick"></AppMenu>

        <div class="layout-mask modal-in"></div>

        <div class="topbar-right">
            <ul class="topbar-menu">
                <li v-if="role!='USER' && $config.sparePartsEnabled()">
                    <a href="#/after-sales/shopping-cart" class="irinox-shopping-cart" tabindex="0" aria-label="Shopping Cart">
                        <i style="background-image: url('assets/irinox/icons/shopping_cart.svg'); justify-content: end;">
                          <Badge v-if="cart?.length>0" :value="cartItemCount" class="cart-badge"></Badge>
                        </i>
                    </a>
                </li>
                <li>
                    <a @click="openLangDialog" class="irinox-lang" tabindex="0">
                        <div>{{langCode}}</div>
                        <i style="background-image: url('assets/irinox/icons/lang.svg')"></i>
                    </a>
                </li>
                <li>
                    <a href="#/account" class="irinox-account" tabindex="0" aria-label="Account">
                        <i style="background-image: url('assets/irinox/icons/account.svg')"></i>
                    </a>
                </li>
            </ul>
        </div>


        <Dialog v-model:visible="langDialog" class="locale-selector" contentClass="p-d-flex p-flex-wrap" :modal="true" :closable="false"  
            :style="{width: '1010px', minWidth: '460px'}" :breakpoints="{'1010px': '820px', '820px': '630px', '630px': '460px'}">
          <div v-for="l in langs" :key="l.code" :class="['p-d-flex','p-jc-center','p-ai-center','p-flex-wrap','','locale-selector-flag',{'selected':l.selected}]" @click="selectLanguage(l.code)">
            <img :src="'assets/irinox/flags/flag-'+l.flag+'.svg'" :alt="l.name" /><br>
            <div>{{l.name}}</div>
          </div>

          <template #footer>
            <Button :label="$t('lang.cancel_button')" class="p-button-secondary" @click="closeLangDialog"/>
            <Button :label="$t('lang.set_language_button')" autofocus @click="setLanguage"/>
          </template>
        </Dialog>
    
    </div>
</template>

<script>
import AppMenu from "./AppMenu";
import AccountService from './service/AccountService';
import AfterSalesService from './service/AfterSalesService';
import { mapGetters } from 'vuex';
export default {
    name: "AppTopbar",
    emits: ["menu-click", "menuitem-click", "root-menuitem-click", "menu-button-click", "search-click", "topbar-notification", "topbar-user-menu", "right-menubutton-click"],
    props: {
        topbarNotificationMenuActive: Boolean,
        topbarUserMenuActive: Boolean,
        layoutMode: String,
        menu: Array,
        menuActive: Boolean,
        staticMenuMobileActive: Boolean
    },
    data() {
        return {
            items: [],
            langDialog: false,
            langs: [{
                code: "en",
                flag: 'gb',
                name: 'English',
                selected: this.$i18n.locale == 'en'
              },{
                code: "it",
                flag: 'it',
                name: 'Italiano',
                selected: this.$i18n.locale == 'it'
              },{
                code: "ru",
                flag: 'ru',
                name: 'русский',
                selected: this.$i18n.locale == 'ru'
              },{
                code: "es",
                flag: 'es',
                name: 'Español',
                selected: this.$i18n.locale == 'es'
              },{
                code: "du",
                flag: 'nl',
                name: 'Nederlands',
                selected: this.$i18n.locale == 'du'
              },{
                code: "fr",
                flag: 'fr',
                name: 'Français',
                selected: this.$i18n.locale == 'fr'
              },{
                code: "de",
                flag: 'de',
                name: 'Deutsche',
                selected: this.$i18n.locale == 'de'
              },{
                code: "en-US",
                flag: 'us',
                name: 'United States',
                selected: this.$i18n.locale == 'en-US'
              },{
                code: "ja",
                flag: 'jp',
                name: 'やまと',
                selected: this.$i18n.locale == 'ja'
              },{
                code: "pt",
                flag: 'br',
                name: 'Português',
                selected: this.$i18n.locale == 'pt'
              },{
                code: "ko",
                flag: 'kr',
                name: '한국어',
                selected: this.$i18n.locale == 'ko'
              },{
                code: "hi",
                flag: 'in',
                name: 'हिन्दी',
                selected: this.$i18n.locale == 'hi'
              },{
                code: "id",
                flag: 'id',
                name: 'Bahasa Indonesia',
                selected: this.$i18n.locale == 'id'
              },{
                code: "zh",
                flag: 'cn',
                name: '中文',
                selected: this.$i18n.locale == 'zh'
              }],
            langSelected: this.$i18n.locale,
            userinfo: null
        };
    },
    components: {
        AppMenu
    },
    computed: {
      ...mapGetters({
        personaltoken: 'userdata/personaltoken',
        role: 'userdata/role',
        cart: 'afterSales/cart'
      }),
      langCode: function() {
        if(this.$i18n.locale==='en-US') {
          return 'US';
        }
        return this.$i18n.locale.toUpperCase();
      },
      cartItemCount() {
        if(this.cart?.length>0) {
          //sum the quantity of all items in the cart
          return this.cart.reduce((total, item) => {
            return total + item.quantity;
          }, 0);
        }
        return 0;
      }
    },
    created() {
      this.accountService = new AccountService();
      this.afterSalesService = new AfterSalesService();
    },
    mounted() {
      this.loadCart();
    },
    unmounted() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    },
    methods: {
      loadCart() {
        if(this.role!='USER' && this.$config.sparePartsEnabled()) {
          this.afterSalesService.getSpCart(this.personaltoken)
            .then((data) => {
              if(data.code==="200") {
                this.$store.commit('afterSales/cart', data.body);
              } else {
                this.$store.commit('afterSales/cart', []);
                console.error(JSON.stringify(data));
              }
            })
            .catch(error => {
              this.$store.commit('afterSales/cart', []);
              console.error("ERROR " + error);
            });
        }
      },
      async getUserData() {
        await this.accountService.getUserinfo(this.personaltoken)
          .then(userinfo => {
            this.userinfo = userinfo;
            this.$store.commit('userdata/updateUserinfo', userinfo);
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
          });
      },
        openLangDialog() {
          this.getUserData();
          this.langDialog = true;
        },
        closeLangDialog() {
          this.langDialog = false;
        },
        async setLanguage() {
          this.$i18n.locale = this.langSelected;
          this.$store.commit('preferences/locale', this.$i18n.locale);
          this.userinfo.language = this.$functions.locale(this.$i18n.locale);
          await this.accountService.putUserinfo(this.personaltoken, this.userinfo);
          this.langDialog = false;
        },
        selectLanguage(code) {
          for(let i = 0; i < this.langs.length; i++) {
            if(this.langs[i].code==code) {
              this.langs[i].selected = true;
              this.langSelected = code;
            } else {
              this.langs[i].selected = false;
            }
          }
        },
        onMenuClick(event) {
            this.$emit("menu-click", event);
        },
        onMenuItemClick(event) {
            this.$emit("menuitem-click", event);
        },
        onRootMenuItemClick(event) {
            this.$emit("root-menuitem-click", event);
        },
        onMenuButtonClick(event) {
            this.$emit("menu-button-click", event);
        },
        onSearchClick(event) {
            this.$emit("search-click", event);
        },
        onTopbarNotificationMenuButtonClick(event) {
            this.$emit("topbar-notification", event);
        },
        onTopbarUserMenuButtonClick(event) {
            this.$emit("topbar-user-menu", event);
        },
        onRightMenuClick(event) {
            this.$emit("right-menubutton-click", event);
        },
        isMobile() {
            return window.innerWidth <= 1091;
        }
    }
};
</script>

<style lang="scss">
.responsive-menu-button {
  background-repeat: no-repeat;
  background-position: center center;
  width: 42px;
  height: 50px;
}

.irinox-account i {
  background-repeat: no-repeat;
  background-position: center center;
  width: 50px;
  height: 50px;
  display: flex;
}
.irinox-shopping-cart i {
  background-repeat: no-repeat;
  background-position: center center;
  width: 50px;
  height: 50px;
  display: flex;
}
.irinox-lang i {
  background-repeat: no-repeat;
  background-position: center center;
  width: 50px;
  height: 50px;
  float: left;
}
.irinox-lang div {
  float: left;
  width: 25px;
  font-weight: 600;
}
.irinox-lang {
  width: 80px !important;
}

.locale-selector {
  border-radius: 860px;
}
.locale-selector .p-dialog-header {
  padding-bottom: 0px !important;
}
.locale-selector-flag {
  width: 180px;
  text-align: center;
  border: 2px solid #FFFFFF;
  border-radius: 28px;
  margin: 5px;
  cursor: pointer;
  padding: 1rem;
}
.locale-selector-flag.selected {
  border: 2px solid #002445;
}
.locale-selector-flag img {
  width: 100px !important;
  height: auto;
}
.locale-selector-flag div {
  font-weight: 600;
  color: #002445;
  line-height: 25px;
}

</style>

